import styled from 'styled-components';
import { PlusCircleFilled, MinusOutlined } from '@ant-design/icons';
import { Checkbox, Tooltip, Badge } from 'antd';

const StyledContainerForInputAddIcon = styled.span`
  position: relative;
  top: -2px;
  right: 0px;

  .badge .anticon {
    transition: color 0.2s ease;
    font-size: 20px;
    cursor: pointer;
    color: ${x => x.theme.colors.yellow};
  }

  &:hover .badge .anticon {
    color: ${x => x.theme.colors.blue};
  }
`;

const StyledContainerForInputMinusIcon = styled.span`
  position: relative;
  bottom: 10px;
  right: 0px;
  height: 20px;

  .badge .anticon {
    transition: color 0.2s ease;
    font-size: 20px;
    cursor: pointer;
    color: ${x => x.theme.colors.yellow};
  }

  &:hover .badge .anticon {
    color: ${x => x.theme.colors.blue};
  }
`;

const YellowCheckbox = styled(Checkbox)`
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${x => x.theme.colors.primary} !important;
    border-color: ${x => x.theme.colors.primary} !important;
  }
`;

const InputAddIcon = (props) => {
  return (
    <StyledContainerForInputAddIcon>
      <Tooltip title={props.tooltip}>
        <Badge className='badge' onClick={props.onClick} count={
          <PlusCircleFilled />} 
        />
      </Tooltip>
    </StyledContainerForInputAddIcon>
  )
};

const InputMinusIcon = (props) => {
  return (
    <StyledContainerForInputMinusIcon>
      <Tooltip title={props.tooltip}>
        <Badge className='badge' onClick={props.onClick} count={
          <MinusOutlined />} 
        />
      </Tooltip>
    </StyledContainerForInputMinusIcon>
  )
};

const HorizontalSeparator = styled.div`
  width: 100%;
  padding: 10px 0;
  border-top: 1px solid #efefef !important;
`;

const FormHorizontalFields = styled.div`
	display: flex;
  width: 100%;

	& > div {
		flex: 1;
		width: 100%;
		margin-right: 5px;
	}

	& > div:last-child {
		margin-right: 0px;
	}

	.ant-input-number, .ant-picker {
		width: 100%;
	}
`;

const JournalEntryButtonContainer = styled.div`
  width: 15px !important;
  flex: inherit !important;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: 24px;
  padding-right: 5px;
`;

export { StyledContainerForInputAddIcon, StyledContainerForInputMinusIcon, InputAddIcon, InputMinusIcon,
  YellowCheckbox, HorizontalSeparator, FormHorizontalFields, JournalEntryButtonContainer }
